class PromoformCheckForDuplicateRequests extends Component {
    promoEventName;
    url;
    customerEmailElement;
    modelElement;

    constructor(el) {
        super(el);

        this.promoEventName = this.$el.dataset.promoEventName;
        this.url = this.$el.dataset.url;
        this.customerEmailElement = this.$el.closest('form').querySelector('#customerEmail');
        this.modelElement = this.$el.closest('[data-component="PromoformProduct"]').querySelector('[data-component="PromoformProductModel"]');
        this.datePlaceholder = this.$el.querySelector('[data-date-placeholder]');

        this.customerEmailElement.addEventListener('change', () => this.updateMessage());
        this.modelElement.addEventListener('change', () => this.updateMessage());
        this.updateMessage();
    }

    updateMessage() {
        if (!this.customerEmailElement.value || !this.modelElement.value) {
            this.$el.style.display = 'none';
            return;
        }

        const formData = new FormData();
        formData.append('promoEventName', this.promoEventName);
        formData.append('customerEmail', this.customerEmailElement.value);
        formData.append('model', this.modelElement.value);
        fetch(this.url, {
            method: "POST",
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.lastRequestFormattedDate) {
                    this.datePlaceholder.textContent = data.lastRequestFormattedDate;
                    this.$el.style.display = '';
                } else {
                    this.$el.style.display = 'none';
                    return false;
                }
            });
    }
}
